import {Box, useTheme} from "@mui/material";
import React, {forwardRef} from "react";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";
import Space from "../../Common/Space";

export const Section = forwardRef(({ title, subtitle, onClick, children }, ref) => {
    const theme = useTheme();

    return <React.Fragment>
        <Box ref={ref} sx={{
            width: "100%",
            backgroundColor: theme.palette.grey["300"],
            padding: "10px 5px",
            boxSizing: "border-box",
        }}
        >
            {title ? (
                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                }}>
                    <Typography
                        variant="h6"
                        sx={{
                            margin: "0px",
                            paddingLeft: "10px",
                            color: theme.palette.grey["700"],
                            fontWeight: "bold",
                        }}
                    >
                        {title}
                    </Typography>
                    <Space width="10px"/>
                    <Typography
                        onClick={onClick}
                        sx={{
                            margin: "0px",
                            paddingTop: "3px",
                            paddingRight: "10px",
                            color: theme.palette.grey["500"],
                            fontSize: "12px",
                            fontWeight: "bold",
                            "&:hover": {
                                cursor: "pointer",
                                color: theme.palette.jagtred.main,
                            }
                        }}
                    >
                        {subtitle}
                    </Typography>
                </Box>
            ) : (
                <Skeleton
                    variant="rounded"
                    width={175}
                    height={30}
                    sx={{marginLeft: "10px"}}
                />
            )}
        </Box>

        <Box
            sx={{
                backgroundColor: theme.palette.grey["100"]
            }}
        >{children}</Box>
    </React.Fragment>
})